<template>
  <ModalPlay size="xl" :title="$t('class_config.community_modal.title', { name: communityName })" :subtitle="$t('class_config.community_modal.subtitle')" @close="$emit('close')">
    <div class="AllContent">
      <div class="tableModule">
        <div class="tw:flex tw:flex-col tw:gap-4">
          <TextPlay :text="$t('class_config.community_modal.instructions_title')" />
          <TextPlay :text="$t('class_config.community_modal.instruction_1')" />
          <TextPlay>
            {{ $t('class_config.community_modal.instruction_2') }}
            <a class="comunidadeLink" :href="communityBaseLink" target="_blank">{{ communityName }}</a>
          </TextPlay>
          <TextPlay :text="$t('class_config.community_modal.instruction_3')" />
          <TextPlay :text="$t('class_config.community_modal.instruction_4')" />
          <TextPlay :text="$t('class_config.community_modal.instruction_5')" />

          <FieldPlay label-for="comunidade-url-input" :label="$t('class_config.community_modal.url_label')">
            <InputPlayV3
              :id="'comunidade-url-input'"
              v-model="state.url"
              :name="'comunidade-url-input'"
              :placeholder="$t('class_config.community_modal.paste_here_placeholder')"
              @update:model-value="atualizarURL"
            />
          </FieldPlay>
        </div>
      </div>
    </div>

    <template #footer>
      <ButtonPlayV2 :text="$t('general.save')" @click="saveComunidade" />
    </template>
  </ModalPlay>
</template>

<script lang="ts" setup>
defineEmits(['close', 'update:comunidadeURL'])

import { ModalPlay } from '@/components/atomic';
import CourseService from "@/services/resources/CourseService";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { toast } from "@/events";

const { t } = useI18n();
const serviceCourse = CourseService.build();


const props = defineProps<{
  community: "circle" | "discord" | "slack",
  classId: string,
  courseId: string
}>()

const state = reactive({
  url: "",
  disabled: false,
})

const communityName = computed(() => {
  return {
    circle: "Circle",
    discord: "Discord",
    slack: "Slack"
  }[props.community]
})

const communityBaseLink = computed(() => {
  return {
    circle: "https://circle.so/",
    discord: "https://discord.com/",
    slack: "https://slack.com/"
  }[props.community]
})


const _addRules = computed(() => {
  return {
    circle: { regex: /circle/i},
    discord: { regex: /discord/i},
    slack: { regex: /slack/i}
  }[props.community]
})

const _regex = computed(() => {
  return /[^a-zA-Z0-9\\.\\-\\_\\@\\#\\$\\%\\^&\\*\\(\\)\\,\\;\\:\\'"\\/\\?\\~\\!]/g
})

function atualizarURL() {
  const regexEmojis = /[^a-zA-Z0-9\\.\\_\\@\\`\\´\\{\\}\\<\\>\\¨\\+\\-\\=\\#\\$\\%\\^&\\*\\(\\)\\,\\;\\:\\'"\\/\\?\\~\\!\\[\\\]\\]/g;
  let url = this.url;
  url = this.url.replace(regexEmojis, '');
  this.url = url;
  this.$emit('update:comunidadeURL', this.url);
}

function saveComunidade(){
  if(this.validaCampo()){
    const data = {
      name: this.comunidadeName,
      url: this.url,
      class_id: this.class_id
    };

    
    serviceCourse
      .post("/"+this.course_id+"/class/community",data)
      .then((resp) => {
        if(resp.message){
          toast.success(resp.message);
        }else if(resp){
          toast.success(t('class_config.community_modal.configured_success'));
        }
      })
      .catch((_err) => {
        toast.error(t('class_config.community_modal.error_configure'));
      });
  }
}

function _validaCampo(){
  if(this.url.length >500){
    toast.error(t('class_config.community_modal.error_char_limit'));
    return false
  }

  if(this.url.length === 0){
    return true;
  }

  for (const rules of this.urlRules) {
      if (Object.prototype.hasOwnProperty.call(rules, this.comunidadeName.toLowerCase())) {
        const validRule = rules[this.comunidadeName.toLowerCase()].regex;
        const valid = validRule.test(this.url)
        if(!valid){
          toast.error(t('class_config.community_modal.error_url_required'));
          return false
        }
      }
    }
    return true;
}

function _getComunidade(option) {
  this.reset()
  

  const data = {
    type: option,
    class_id: this.class_id
  };
  serviceCourse
    .post("/"+this.course_id+"/class/community/get",data)
    .then((resp) => {
      this.disabled = false
      this.url = resp.json
      
    })
    .catch((_err) => {
      
    });
}

function _reset() {
  this.url = ""
  this.disabled = true
}

</script>
